window.PartnersRewards = (function($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            classNames: {
                pickAndPlayContent: '#partner-page-container',
                 mainContent: '.vds-main-content',
                 hiddenItem: 'vds-item-hidden'
            }
        },
        func: {
            init: function () {
                const projectUnoToggle = ($('#page-data').data('feature-toggle') === 'False');
                if (!projectUnoToggle) {
                    $(self.elements.classNames.mainContent).addClass(self.elements.classNames.hiddenItem);
                    $( self.elements.classNames.pickAndPlayContent).removeClass(self.elements.classNames.hiddenItem);
                }  else   {
                    $(self.elements.classNames.mainContent).removeClass(self.elements.classNames.hiddenItem);
                    $( self.elements.classNames.pickAndPlayContent).addClass(self.elements.classNames.hiddenItem);
                }
            },
        }
    };
    return {
        init: self.func.init,
    };

})(window.jQuery);

$('document').ready(function () {
    const partnerRewards = ($('#page-data').data('page-name') === 'PartnersRewards');
    if(partnerRewards) {
        window.PartnersRewards.init();
    }
});
